<template>
	<span class="annotation sentence-highlight"><slot></slot></span>
</template>

<script setup></script>

<style scoped lang="less">
@import './highlight-colors.less';

.sentence-highlight {
	position: relative;
	z-index: 1;

	&:before {
		content: ' ';
		position: absolute;
		left: -2px;
		width: calc(100% + 4px);
		top: 0%;
		height: 100%;
		border-radius: 8px;
		z-index: -10;
		opacity: 0.7;
	}
}

.annotation:before {
	.highlight-annotation;
}

.annotation-1:before {
	background-color: pink;
}
.annotation-2:before {
	background-color: lightgreen;
}
.annotation-3:before {
	background-color: lightblue;
}
.annotation-4:before {
	background-color: lightyellow;
}
.annotation-5:before {
	background-color: lightcoral;
}
.annotation-6:before {
	background-color: lightcyan;
}
.annotation-7:before {
	background-color: lightgoldenrodyellow;
}
.annotation-8:before {
	background-color: lightgray;
}

.annotation-main:before {
	background-color: fade(@dm-orange, 35%);
	border-radius: 4px;
}

.annotation-secondary:before {
	background-color: fade(@dm-teal, 25%);
	border-radius: 4px;
}

.annotation-main-secondary {
	background-color: fade(@dm-teal, 25%);
	padding: 0 2px;
	border-radius: 4px;
}

.annotation-main-secondary::before {
	background-color: fade(@dm-orange, 25%);
	margin-left: 2px;
	width: 100%;
	border-radius: 4px;
}
</style>
